__turbopack_context__.v({
  "answer": "explorers-module__JTiA4W__answer",
  "answerLabel": "explorers-module__JTiA4W__answerLabel",
  "button": "explorers-module__JTiA4W__button",
  "caption": "explorers-module__JTiA4W__caption",
  "choices": "explorers-module__JTiA4W__choices",
  "client": "explorers-module__JTiA4W__client",
  "clientHead": "explorers-module__JTiA4W__clientHead",
  "compare": "explorers-module__JTiA4W__compare",
  "connection": "explorers-module__JTiA4W__connection",
  "contract": "explorers-module__JTiA4W__contract",
  "definition": "explorers-module__JTiA4W__definition",
  "detail": "explorers-module__JTiA4W__detail",
  "explorer": "explorers-module__JTiA4W__explorer",
  "eyebrow": "explorers-module__JTiA4W__eyebrow",
  "figure": "explorers-module__JTiA4W__figure",
  "gateBody": "explorers-module__JTiA4W__gateBody",
  "gateList": "explorers-module__JTiA4W__gateList",
  "gateState": "explorers-module__JTiA4W__gateState",
  "heading": "explorers-module__JTiA4W__heading",
  "interfaceGrid": "explorers-module__JTiA4W__interfaceGrid",
  "intro": "explorers-module__JTiA4W__intro",
  "ledger": "explorers-module__JTiA4W__ledger",
  "limit": "explorers-module__JTiA4W__limit",
  "number": "explorers-module__JTiA4W__number",
  "question": "explorers-module__JTiA4W__question",
  "quiet": "explorers-module__JTiA4W__quiet",
  "receipt": "explorers-module__JTiA4W__receipt",
  "source": "explorers-module__JTiA4W__source",
  "sourceGrid": "explorers-module__JTiA4W__sourceGrid",
  "sourceHeader": "explorers-module__JTiA4W__sourceHeader",
  "steps": "explorers-module__JTiA4W__steps",
});
